export function isOddNumber(number) {
    if (typeof number !== 'number'){
        return false;
    }
    return number % 2 !== 0;
};